import { useEffect, useState } from "react";
import { getApi } from "../../../services/api/globalApi";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { utilsState } from "../../../sotre/redux/features/utilsSlice";
import AllOrderReportsFilter from "./AllOrderReportsFilter";
import Button from "../../../components/common/button/Button";
import FixOrderDateModal from "../../orders/sub-components/fix-date-modal/FixOrderDateModal";
import { convertDate } from "../../../utils/convertDate";
import * as XLSX from "xlsx";
import moment from "jalali-moment";
import OrderCard from "../../../components/common/cards/order-card/OrderCard";
import { errorMessage } from "../../../utils/toastify-message/ToastifyMessage";
import { digitsThree } from "../../../utils/price";

function AllOrderReports() {
  const [data, setData] = useState([]);
  const [showFixModal, setShowFixModal] = useState(false);

  const { utils } = useSelector(utilsState);

  const getOrders = async (params) => {
    const path = "admin/reports/withoutPaginatePaidOrders";
    try {
      const response = await getApi({
        path,
        params,
      });
      setData(response.data.result);
    } catch (error) {
      errorMessage(error.response?.data.errors[0]?.message);
    }
  };

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    getOrders(allFilter);
  };

  useEffect(() => {
    filterDataHandler({
      from: moment().locale("en").format("YYYY-MM-DD"),
      to: moment().locale("en").format("YYYY-MM-DD"),
    });
  }, []);

  const navigate = useNavigate();

  const getOrderInfo = (id) => {
    navigate(`/order-list/${id}`);
  };
  const editOrder = (id) => {
    navigate(`/order-list/${id}`);
  };

  const handleExel = () => {
    const newData = [];
    for (let j = 0; j < data.length; j++) {
      for (let i = 0; i <= data[j]?.products?.length; i++) {
        if (i == 0) {
          const coupons = data[j]?.coupons?.map((item) => item.code);
          const totalBuyPrice = data[j]?.products?.reduce(
            (sum, item) => sum + (item.isGift ? 0 : (item.totalBuyPrice || 0)),
            0
          );
          const totalItemsCount = data[j]?.products?.reduce(
            (sum, item) => sum + (item.count || 0),
            0
          );
          const paymentDate = new Date(data[j]?.paymentDate);
          const bugStartDate = new Date("2025-11-22T00:00:00.000Z");
          const bugEndDate = new Date("2025-11-23T23:59:59.999Z");
          const isBugPeriod = paymentDate >= bugStartDate && paymentDate <= bugEndDate;
          let discountPercentage = 0;
          if (isBugPeriod) {
            const savedDiscountPercentage = data[j]?.discounts
              ?.filter((item) => item.type !== "userLevel")
              ?.reduce((sum, item) => sum + (item.percent || 0), 0) || 0;
            let calculatedProductCountDiscount = 0;
            if (totalItemsCount >= 6) {
              calculatedProductCountDiscount = 20;
            } else if (totalItemsCount >= 4) {
              calculatedProductCountDiscount = 15;
            } else if (totalItemsCount >= 2) {
              calculatedProductCountDiscount = 10;
            }
            discountPercentage = savedDiscountPercentage > 0 ? savedDiscountPercentage : calculatedProductCountDiscount;
          } else {
            discountPercentage = data[j]?.discounts
              ?.filter((item) => item.type !== "userLevel")
              ?.reduce((sum, item) => sum + (item.percent || 0), 0) || 0;
          }
          newData.push({
            "نام کاربر": data[j]?.user?.name,
            نقش: utils?.ROLES[data[j]?.user?.role]?.name,
            "مشتری نماینده": data[j]?.ref ? "بله" : "",
            "موبایل کاربر": data[j]?.user?.mobile,
            فروشنده: data[j]?.linkCode
              ? utils?.SOCIAL_MEDIA_LINK_CODE[data[j]?.linkCode]?.name
              : "",
            "نام مشتری": data[j]?.name,
            "موبایل مشتری": data[j]?.mobile,
            "شماره سفارش": `${data[j]?.trackingCode}`,
            "هزینه حملو نقل": `${data[j]?.shippingFinalPrice}`,
            "مبلغ پرداختی": `${data[j]?.finalPrice}`,
            "مجموع قیمت خرید": `${digitsThree(totalBuyPrice) || 0}`,
            "کد های تخفیف": coupons?.toString(),
            "مجموع ناخالص (بدون حملو نقل)": Math.floor(
              data[j]?.totalProductsPrice
            ),
            "مجموع قیمت خالص محصولات": data[j]?.finalProductsPrice,
            "مجموع تعداد اقلام سفارش": totalItemsCount,
            "درصد تخفیف": `${discountPercentage}%`,
            آدرس: `${data[j]?.province} - ${data[j]?.city}- ${data[j]?.address}`,
            "کد پستی": `${data[j]?.postcode}`,
            تاریخ: convertDate(data[j]?.paymentDate) || "",
          });
        } else {
          const categories = data[j]?.products[i - 1].product?.categories?.map(
            (item) => item.name
          );
          const product = data[j]?.products[i - 1];
          const count = product.count;
          const basePrice = product.basePrice;
          const productVarSku = product.productVarSku;
          const productSku = product.productSku;
          newData.push({
            "نام کاربر": data[j]?.user?.name,
            نقش: utils?.ROLES[data[j]?.user?.role]?.name,
            "مشتری نماینده": data[j]?.ref ? "بله" : "",
            "موبایل کاربر": data[j]?.user?.mobile,
            فروشنده: "",
            "نام مشتری": data[j]?.name,
            "موبایل مشتری": data[j]?.mobile,
            "نام محصول": product.productName,
            "دسته بندی": categories?.length ? String(categories) : "",
            "شناسه محوصل": productVarSku || productSku,
            تعداد: count,
            "قیمت محصول": basePrice,
            "مجموع قیمت محصول": count * basePrice,
          });
        }
      }
    }
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(newData);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
    XLSX.writeFile(workbook, "exported_data.xlsx");
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      {showFixModal && (
        <FixOrderDateModal
          onClose={() => setShowFixModal(false)}
          onSuccess={() => getOrders(filter || {})}
        />
      )}
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h3 className="text-gray-800">لیست تمام سفارشات</h3>
        <div className="flex flex-wrap items-center gap-2">
          <Button
            color="danger"
            type="button"
            onClick={() => setShowFixModal(true)}
            text="اصلاح تاریخ سفارش"
          />
          {data?.length ? (
            <Button
              color="success"
              type="button"
              onClick={handleExel}
              text={"خروجی اکسل"}
            />
          ) : null}
        </div>
      </div>
      <div className="border-b border-gray-200 dark:border-gray-700">
        <AllOrderReportsFilter filterDataHandler={filterDataHandler} />
      </div>
      <div className="flex flex-wrap gap-3 items-center justify-between my-2 mt-4 mr-4">
        <p className="text-sm text-gray-600 dark:text-gray-300">
          تعداد نتایج:{" "}
          <span className="font-semibold">{data?.length || 0}</span>
        </p>
      </div>
      <div className="mt-4 w-full flex flex-col gap-4">
        {data.length > 0 &&
          data.map((item, index) => {
            return (
              <OrderCard
                reGetData={() => getOrders({})}
                utils={utils}
                key={index}
                data={item}
                editOrder={editOrder}
                getOrderInfo={getOrderInfo}
                showImages={false}
              />
            );
          })}
      </div>
    </div>
  );
}

export default AllOrderReports;
